// Template for check minus (uncheck a checkbox)
export default function() {

  let minus = "<svg width=\'12\' height=\'12\' class=\'checkbox-minus clickable\' viewBox=\'0 0 16 16\' "
  minus += "fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'>";
  minus += "<path stroke=\'#0B090F\' stroke-linecap=\'round\' stroke-linejoin=\'round\' d=\'M4.267 8h7.466\'></path>";

  return minus;

}